import InputNumber from './index.vue';

export default InputNumber;
